/**
 * "Terms of Service and Privacy Policy" with links (audit P-4, 2026-10-21).
 * URLs come from the Backend; only absolute https links are rendered as links
 * (anything else shows as plain text), opened in a new tab without opener.
 *
 * The in-app /terms and /privacy routes (audit P-12, 2026-10-22) exist and are
 * linkable on their own; this component keeps its Backend-URL-only behaviour so
 * the consent dialog's https-only guarantee is unchanged.
 */
import React from 'react';
import { Link } from '@mui/material';

export function safeHttpsUrl(value) {
  if (typeof value !== 'string') return null;
  try {
    const u = new URL(value);
    return u.protocol === 'https:' ? u.href : null;
  } catch {
    return null;
  }
}

function DocLink({ href, children }) {
  const url = safeHttpsUrl(href);
  if (!url) return <span>{children}</span>;
  return (
    <Link href={url} target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  );
}

export default function TermsLinks({ terms }) {
  return (
    <>
      <DocLink href={terms?.termsUrl}>Terms of Service</DocLink>
      {' and '}
      <DocLink href={terms?.privacyUrl}>Privacy Policy</DocLink>
    </>
  );
}
